import { render, staticRenderFns } from "./reject_reasons.vue?vue&type=template&id=067af04c&scoped=true&"
import script from "./reject_reasons.vue?vue&type=script&lang=js&"
export * from "./reject_reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067af04c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067af04c')) {
      api.createRecord('067af04c', component.options)
    } else {
      api.reload('067af04c', component.options)
    }
    module.hot.accept("./reject_reasons.vue?vue&type=template&id=067af04c&scoped=true&", function () {
      api.rerender('067af04c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains_registration_requests/actions/reject_reasons.vue"
export default component.exports